module.exports = __webpack_public_path__ + "static/318476315_666025191860586_5734426816503227517_n.jpg-1671186392511_256-b9684edc0803e7b8e7d62b6c1835739d.webp";